<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const emit = defineEmits(['completed', 'declined']);
const { t } = useI18n();

const dialogRef = ref(null);
const signingUrl = ref('');

const reset = () => {
  signingUrl.value = '';
};

const handleMessage = event => {
  if (event.data?.type === 'docuseal:complete') {
    emit('completed');
    close();
  } else if (event.data?.type === 'docuseal:decline') {
    emit('declined');
    close();
  }
};

onMounted(() => {
  window.addEventListener('message', handleMessage);
});

onBeforeUnmount(() => {
  window.removeEventListener('message', handleMessage);
});

const open = url => {
  reset();
  signingUrl.value = url;
  dialogRef.value?.open();
};

const close = () => dialogRef.value?.close();

const handleClose = () => {
  reset();
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="t('DOCUMENTS.SIGNATURES.SIGN_NOW_DIALOG.TITLE')"
    width="5xl"
    overflow-y-auto
    :show-cancel-button="false"
    :show-confirm-button="false"
    @close="handleClose"
  >
    <div v-if="signingUrl" class="min-h-[600px]">
      <iframe
        :src="signingUrl"
        class="w-full h-[600px] border-0"
      />
    </div>
  </Dialog>
</template>
